import { ClientProfileImageFileConstraints } from '../types';

export const HEADER_LOGO_CONSTRAINTS: ClientProfileImageFileConstraints = {
  name: 'headerLogo',
  imageDimensions: {
    width: 120,
    height: 60,
  },
  imageDimensionsConstraint: 'Image size should not exceed 100x100 or 120x60 pixels.',
  maxFileSize: 204800,
  fileSizeConstraint: 'File size should not exceed 200 KB.',
  acceptedFileTypes: { 'image/svg+xml': [], 'image/png': [] },
  fileTypesConstraint: 'Supported format such as .png, .svg',
};

export const FOOTER_LOGO_CONSTRAINTS: ClientProfileImageFileConstraints = {
  name: 'footerLogo',
  imageDimensions: {
    width: 200,
    height: 200,
  },
  imageDimensionsConstraint: 'Image size should not exceed 200x200 or 140x60 pixels.',
  maxFileSize: 204800,
  fileSizeConstraint: 'File size should not exceed 200 KB.',
  acceptedFileTypes: { 'image/svg+xml': [], 'image/png': [] },
  fileTypesConstraint: 'Supported format such as .png, .svg',
};

export const HEADER_IMAGE_CONSTRAINTS: ClientProfileImageFileConstraints = {
  name: 'headerImage',
  imageDimensions: {
    width: 1920,
    height: 533,
  },
  imageDimensionsConstraint: 'Image size should not exceed 1440x400 or 1920x533 pixels.',
  maxFileSize: 5242880,
  fileSizeConstraint: 'File size should not exceed 5 MB.',
  acceptedFileTypes: { 'image/jpeg': [], 'image/png': [] },
  fileTypesConstraint: 'Supported format such as .jpeg, .png',
};

export const FOOTER_IMAGE_CONSTRAINTS: ClientProfileImageFileConstraints = {
  name: 'footerImage',
  imageDimensions: {
    width: 1920,
    height: 1066,
  },
  imageDimensionsConstraint: 'Image size should not exceed 1440x800 or 1920x1066 pixels.',
  maxFileSize: 5242880,
  fileSizeConstraint: 'File size should not exceed 5 MB.',
  acceptedFileTypes: { 'image/jpeg': [], 'image/png': [] },
  fileTypesConstraint: 'Supported format such as .jpeg, .png',
};
